export const getPreviewStyles = () => ({
  adPreviewContainer: {
    '& .new-preview-carousel-container-adprelib': {
      width: '610px',
      minWidth: '610px',
    },
  },
});
